import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(ButtonBase)`
  position: relative;
  min-width: 100px;
  aspect-ratio: 1;
  border-radius: var(--radius-l);
  background: linear-gradient(var(--c-nl-800), var(--c-nl-600))
    var(--board-color, var(--c-nd-100));
  padding: var(--double-unit) var(--quadruple-unit) var(--double-unit);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit);
  justify-content: center;

  &.selected {
    border: 2px solid var(--c-white);
  }
`;

const TopRightSlot = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: absolute;
  top: var(--unit);
  right: var(--unit);
  width: calc(var(--double-unit));
  height: calc(var(--double-unit));
`;

const TopLeftSlot = styled(Vertical).attrs({ gap: 0, center: true })`
  position: absolute;
  top: var(--unit);
  left: var(--unit);
`;

type Props = {
  topRight?: ReactNode;
  topLeft?: ReactNode;
  background?: string;
  selected?: boolean;
  children: ReactNode;
  onClick?: () => void;
};

export const PickerCard = ({
  topRight,
  topLeft,
  background,
  selected,
  children,
  onClick,
}: Props) => (
  <Root
    type="button"
    className={classNames({ selected })}
    style={
      background
        ? ({ '--board-color': background } as React.CSSProperties)
        : undefined
    }
    onClick={onClick}
  >
    {!!topRight && <TopRightSlot>{topRight}</TopRightSlot>}
    {!!topLeft && <TopLeftSlot>{topLeft}</TopLeftSlot>}
    {children}
  </Root>
);
